var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgH3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.11 14.218c.355.287.749.523 1.17.7.434.181.9.273 1.37.27.484.017.965-.086 1.4-.3a.92.92 0 00.55-.84 1.136 1.136 0 00-.15-.58c-.123-.191-.3-.34-.51-.43a3.649 3.649 0 00-1-.27 9.784 9.784 0 00-1.52-.1v-1.57a4.73 4.73 0 002.17-.36 1.06 1.06 0 00.63-.93.9.9 0 00-.38-.81c-.34-.203-.734-.3-1.13-.28a2.836 2.836 0 00-1.14.28 5.57 5.57 0 00-1.06.62l-1.22-1.39a6.55 6.55 0 011.64-.9 5.354 5.354 0 011.9-.33 6.448 6.448 0 011.56.17c.431.101.84.277 1.21.52.325.211.595.495.79.83.19.342.287.729.28 1.12.011.48-.177.943-.52 1.28a3.866 3.866 0 01-1.46.86v.06c.609.14 1.175.425 1.65.83.437.382.68.94.66 1.52.005.421-.113.835-.34 1.19-.23.357-.538.657-.9.88a4.463 4.463 0 01-1.32.55 6.391 6.391 0 01-1.57.19 6.419 6.419 0 01-2.31-.37 4.29 4.29 0 01-1.57-1l1.12-1.41zM9 11H5V7H3v10h2v-4h4v4h2V7H9v4z"
  })));
}

export default "/images/h3.svg?d8262db3f22f7b0d78299bd9d21e03d6";
export { SvgH3 as ReactComponent };